$(function () {
    var $form = $('#contactForm');

    if (!$form.length || !window.isRecaptchaEnabled) {
        return;
    }

    var siteKey = window.googleRecaptchaChallengeBasedSiteKey;

    if (!siteKey) {
        return;
    }

    var $tokenInput = $('#recaptchaToken');

    function renderRecaptcha() {
        if (!window.grecaptcha || !window.grecaptcha.enterprise) {
            setTimeout(renderRecaptcha, 300);
            return;
        }

        window.grecaptcha.enterprise.ready(function () {
            window.grecaptcha.enterprise.render('recaptchaWidget', {
                sitekey: siteKey,
                action: 'contact',
                callback: function (token) {
                    $tokenInput.val(token);
                },
            });
        });
    }

    renderRecaptcha();
});
